// @ts-nocheck
import { useState } from "react";
import { PageHeader } from "../components/layout/PageHeader";
import { useLang } from "../lib/lang";

const TICKETS = [
  { id: 1, title_en: "How to connect a new WhatsApp device?", title_he: "כיצד לחבר מכשיר וואטסאפ חדש?", status: "open", createdAt: "2026-04-10" },
  { id: 2, title_en: "Bulk message not sending to all contacts", title_he: "הודעה קבוצתית לא נשלחת לכל אנשי הקשר", status: "resolved", createdAt: "2026-04-05" },
];

export function Support() {
  const { t, lang } = useLang();
  const d = t.support;

  const [showForm, setShowForm] = useState(false);
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");

  return (
    <div>
      <PageHeader title={d.title} actions={[{ label: d.newTicket, icon: "fas fa-plus", onClick: () => setShowForm(true) }]} />

      <div className="px-6 pb-6 space-y-6">
        <div className="bg-white rounded-xl shadow-sm border border-[#e9ecef] p-5">
          <h4 className="text-sm font-semibold text-[#32325d] mb-4">{d.faqTitle}</h4>
          <div className="space-y-3">
            {d.faqs.map((q, i) => (
              <div key={i} className="flex items-start gap-3 p-3 rounded-lg hover:bg-[#f8f9fe] cursor-pointer group">
                <i className="fas fa-question-circle text-[#1171ef] mt-0.5 shrink-0" />
                <p className="text-sm text-[#525f7f] group-hover:text-[#32325d]">{q}</p>
                <i className="fas fa-chevron-end text-[#cad1d7] ms-auto shrink-0 text-xs mt-1" />
              </div>
            ))}
          </div>
        </div>

        {showForm && (
          <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg">
              <div className="flex items-center justify-between px-6 py-4 border-b border-[#e9ecef]">
                <h5 className="font-semibold text-[#32325d]">{d.submitTicket}</h5>
                <button onClick={() => setShowForm(false)} className="text-[#8898aa] hover:text-[#32325d]"><i className="fas fa-times" /></button>
              </div>
              <form className="p-6 space-y-4" onSubmit={e => { e.preventDefault(); setShowForm(false); }}>
                <div>
                  <label className="block text-xs font-semibold text-[#525f7f] mb-1.5">{d.subject}</label>
                  <input value={subject} onChange={e => setSubject(e.target.value)} className="w-full border border-[#cad1d7] rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#1171ef]/30 focus:border-[#1171ef]" placeholder={d.subjectPlaceholder} required />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-[#525f7f] mb-1.5">{d.message}</label>
                  <textarea value={body} onChange={e => setBody(e.target.value)} rows={5} className="w-full border border-[#cad1d7] rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#1171ef]/30 focus:border-[#1171ef] resize-none" placeholder={d.messagePlaceholder} required />
                </div>
                <div className="flex justify-end gap-2">
                  <button type="button" onClick={() => setShowForm(false)} className="px-4 py-2 text-sm border border-[#e9ecef] rounded-lg text-[#525f7f]">{t.common.cancel}</button>
                  <button type="submit" className="px-4 py-2 text-sm gradient-primary text-white rounded-lg shadow-sm">{d.submit}</button>
                </div>
              </form>
            </div>
          </div>
        )}

        <div className="bg-white rounded-xl shadow-sm border border-[#e9ecef]">
          <div className="px-5 py-4 border-b border-[#e9ecef]">
            <h4 className="text-sm font-semibold text-[#32325d]">{d.myTickets}</h4>
          </div>
          {TICKETS.length === 0 ? (
            <div className="p-12 text-center">
              <i className="fas fa-ticket-alt text-4xl text-[#cad1d7] mb-3 block" />
              <p className="text-[#8898aa] text-sm">{d.noTickets}</p>
              <p className="text-[#adb5bd] text-xs mt-1">{d.noTicketsHint}</p>
            </div>
          ) : (
            <div className="divide-y divide-[#f6f9fc]">
              {TICKETS.map(ticket => (
                <div key={ticket.id} className="px-5 py-4 flex items-center justify-between hover:bg-[#f8f9fe] cursor-pointer">
                  <div>
                    <p className="text-sm font-medium text-[#32325d]">{lang === "he" ? ticket.title_he : ticket.title_en}</p>
                    <p className="text-xs text-[#8898aa] mt-0.5">{ticket.createdAt}</p>
                  </div>
                  <span className={`text-xs font-medium px-2.5 py-0.5 rounded-full ${ticket.status === "open" ? "bg-[#fff3cd] text-[#856404]" : "bg-[#d4edda] text-[#155724]"}`}>
                    {ticket.status === "open" ? d.open : d.resolved}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
